module.exports = __webpack_public_path__ + "static/img/ptld_8@2x.07464b8d.png";